define(
({
  "no_data_message": "Brak wpisów",
  "order_number": "Nr zamówienia",
  "elastic_order_number": "Nr zamówienia Elastic",
  "line_number": "Nr linii",
  "customer_name": "Nazwa klienta",
  "customer_number": "Klient nr",
  "location_number": "Lokalizacja nr",
  "location_name": "Nazwa lokalizacji",
  "product": "Nr produktu",
  "style_name": "Nazwa produktu",
  "code": "Kod koloru",
  "color": "Nazwa koloru",
  "status": "Status linii",
  "states": "Status zamówienia",
  "tracking": "Nr do śledzenia",
  "parcel_number": "Paczka nr",
  "year": "Rok",
  "season": "Sezon",
  "order_date": "Data utworzenia",
  "cancel_date": "Anuluj według daty",
  "invoice_date": "Data faktury",
  "invoice": "Faktura nr",
  "invoice_url": "URL faktury",
  "download": "Pobierz",
  "view": "Wyświetl",
  "ship_date": "Żądana data wysyłki",
  "expected_ship_date": "Szacowana data wysyłki",
  "terms_name": "Nazwa regulaminu",
  "po_number": "Nr zamówienia",
  "size": "Rozmiar",
  "alt_name": "Długość rozmiaru",
  "upc": "UPC",
  "units": "Ilość",
  "amount": "Ilość",
  "net_price": "Netto",
  "unit_price": "Cena jednostki",
  "orders": "Zamówienia",
  "totals": "Łącznie",
  "details": "Szczegóły",
  "open": "Otwórz",
  "shipped": "Wysłano",
  "cancelled": "Anulowano",
  "canceled": "Anulowano",
  "released": "Wydany",
  "invoiced": "Zafakturowano",
  "picked": "Odebrany",
  "region": "Region",
  "order_type": "Typ zamówienia",
  "backorder_date": "Data zamówienia zaległego",
  "backorder": "Zamówienie zaległe",
  "payment_terms": "Regulamin płatności",
  "ship_via": "Wyślij przez",
  "line_discount": "Rabat liniowy",
  "rma_number": "RMA nr",
  "cash_discount": "Rabat gotówkowy",
  "hold_for_confirmation": "Wstrzymane do potwierdzenia",
  "credit_hold": "Wstrzymanie kredytu",
  "order_notes": "Notatki zamówienia",
  "product_series": "Seria produktu",
  "product_category": "Kategoria produktu",
  "product_sub_category": "Podkategoria produktu",
  "quantity_confirmed": "Potwierdzono",
  "quantity_backordered": "Zamówienie zaległe",
  "quantity_cancelled": "Anulowano",
  "quantity_shipped": "Wysłano",
  "ivendix_order_id": "iVendix ID",
  "catalog": "Katalog",
  "source": "Źródło",
  "division": "Podział",
  "actual_ship_date": "Rzeczywista data wysyłki",
  "rep_name": "Nazwisko przedstawiciela",
  "tracking_carrier": "Kod przewoźnika",
  "gross_amount": "Kwota brutto",
  "discount_percent": "Rabat %"
})
);
